import getVariantInventory from './get-variant-inventory';

export default {
  getVariantInventory,
};
